import { eq } from "drizzle-orm";
import { Button } from "@mui/material";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { db } from "@/db/db";
import { feed } from "@/db/schema";
import { AppContext } from "@/models/AppStateProvider";
import { emptyQuery } from "@/models/emptyQuery.ts";
import { useReactiveRelationalQuery } from "@/models/hooks/useReactiveRelationalQuery.ts";

function getFeed(feedId?: string) {
  const query = db.query.feed.findFirst({
    where: eq(feed.id, feedId),
  });
  if (feedId) {
    return query;
  } else {
    return emptyQuery as unknown as typeof query;
  }
}
export default function RedirectNotification() {
  const { flags } = useContext(AppContext);
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const feedId = params.get("feedId");
  const itemId = params.get("itemId");

  const feedRecord = useReactiveRelationalQuery(getFeed, [feedId], "RedirectNotification.getFeed");

  useEffect(() => {
    if (!feedRecord) return;

    const hash = itemId ? `#${itemId}` : "";

    if (flags.newDesign && feedRecord.aliasMembershipId) {
      window.location.href = `/workspaces/${feedRecord.workspaceId}/drivers/${feedRecord.aliasMembershipId}/channel/${feedRecord.id}${hash}`;
    } else if (flags.newDesign) {
      window.location.href = `/workspaces/${feedRecord.workspaceId}/channels/${feedRecord.id}${hash}`;
    } else {
      window.location.href = `/workspaces/${feedRecord.workspaceId}/feeds/${feedRecord.id}${hash}`;
    }
  }, [feedRecord, flags.newDesign, itemId]);

  return <Button onClick={() => navigate("/workspaces/")}>Home</Button>;
}
